import React from 'react';
import { Row, Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/**
 *
 */
class Layout_multiple_vertical  extends Layout_base {
  render() {
    return (
      <Col xs={12}>
        {this.sectionHead()}
        <Row>
          <Col sm={4}>{this.componentDOM(0)}</Col>
          <Col sm={4}>{this.componentDOM(1)}</Col>
          <Col sm={4}>{this.componentDOM(2)}</Col>
        </Row>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_multiple_vertical;
